const status = {
  published: 'Publicado',
  unpublished: 'Borrador',
  solved: 'Resuelto',
  unsolved: 'Sin resolver',
  complete: 'Completada',
  out_of_time: 'Destiempo',
  on_time: 'En tiempo',
  active: 'Pediente',
  inactive: 'Programada'
}
export default function (value) {
  return status[value] || value
}



// WEBPACK FOOTER //
// ./src/filters/status.filter.js